<i
  data-test-selector="solo-or-group-icon"
  class="circle {{ colorClass }} {{ iconClass }} fa"
  [ngClass]="showVizientIcon ? 'vizient-rounded-icon' : isSolo ? 'solo' : 'group'"
></i>
